import React from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

export const RefreshButton = ({ handleRefresh, map }) => {
  const refreshMap = () => {
    map?.current?.flyTo({
      center: [69.3451, 30.3753],
      zoom: 5,
      bearing: 0,
    });
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          right: '0.7%',
          zIndex: 1,
          background: 'white',
          borderRadius: '50%',
          bottom: '12%',
          padding: '2px',
        }}
      >
        <Tooltip title="Refresh">
          <IconButton
            aria-label="refresh"
            onClick={handleRefresh}
            sx={{
              color: '#BD1D23',
              border: '1px solid white',
              borderRadius: '50%',
              padding: '2px',
              backgroundColor: 'white',
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </div>
    </>
  );
};
